import { UPDATE_EARLY_COD_CHARGES_SUCCESS, UPDATE_EARLY_COD_CHARGES_REQUEST, UPDATE_EARLY_COD_CHARGES_FAILURE, UPDATE_EARLY_COD_CHARGES_RESET, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const updateEarlyCODChargesReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_EARLY_COD_CHARGES_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, error: null });
        case UPDATE_EARLY_COD_CHARGES_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, data: action.payload, error: null });
        case UPDATE_EARLY_COD_CHARGES_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case UPDATE_EARLY_COD_CHARGES_RESET:
            return Object.assign({}, initialState);
        default:
            return state;
    }
};
export default updateEarlyCODChargesReducer;
